import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const flashMessageModule = namespace('flashMessage')

@Component
export default class NotificationMixin extends Vue {
  @flashMessageModule.Action('setMessage') setFlashMessage!: Function
}
